<ng-template let-extraClass="extraClass" #topNav>
  @if (!windowService.isDesktopRes) {
    <tidy-top-nav
      [class]="extraClass"
      [canGoBack]="true"
      [customBack]="'more'"
      [title]="'Reservations'"
      [showLinkIcon]="true"
      [linkIcon]="'add-circle'"
      (linkAction)="goToAddReservation()" />
  }
</ng-template>

<ng-container
*ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>


    @if (windowService.isDesktopRes) {
      <tidy-desktop-header>
        <div class="wrappable-container">
          <tidy-image
            [src]="'assets/svg/arrow-back-black.svg'"
            (action)="goBack()"
            class="desktop-back-icon" />
          <tidy-text
            [title]="'Reservations'" />
          <form [formGroup]="form" novalidate action="#">
            <tidy-header-select
              [items]="addressFilter"
              [form]="form.get('selectedAddress')"
              formControlName="selectedAddress"
              (optionChange)="onFilterValueChange($event, 'address')"
              [icon]="'assets/svg/home.svg'" />
          </form>
          <form [formGroup]="form" novalidate action="#">
            <tidy-header-select
              [items]="stateFilter"
              [form]="form.get('selectedState')"
              formControlName="selectedState"
              (optionChange)="onFilterValueChange($event, 'state')"
              [icon]="'assets/svg/flag.svg'" />
          </form>
          <tidy-small-button
            [text]="'Add Reservation'"
            [image]="'assets/img/add-button-white.svg'"
            (buttonClick)="goToAddReservation()" />
        </div>
      </tidy-desktop-header>
    }

    @if (errorMessage) {
      <tidy-error-message [text]="errorMessage" />
    }

    @if (loaded) {
      @if (!windowService.isDesktopRes) {
        <div class="custom-desktop-header">
          @if (!isDataLoaded) {
            <div style="width: 100%">
              <ion-skeleton-text
                animated="true"
              style="height: 40px; border-radius: 6px" />
            </div>
          }
          @if (isDataLoaded) {
            <form [formGroup]="form" novalidate action="#" class="form-filters">
              <tidy-header-select
                [items]="addressFilter"
                [form]="form.get('selectedAddress')"
                formControlName="selectedAddress"
                (optionChange)="onFilterValueChange($event, 'address')"
                [icon]="'assets/svg/home.svg'" />
              <tidy-header-select
                [items]="stateFilter"
                [form]="form.get('selectedState')"
                formControlName="selectedState"
                (optionChange)="onFilterValueChange($event, 'state')"
                [icon]="'assets/svg/flag.svg'" />
            </form>
          }
        </div>
      }
      <!-- Skeleton table while loading — rows float in with the entrance cascade;
           the real table below then replaces it in place, instantly (skipEntrance). -->
      @if (!isDataLoaded) {
        <tidy-table
          [skeletonLoading]="true"
          [columnslabels]="headers" />
      }
      @if (isDataLoaded) {
        @if (currentRows?.length > 0) {
          <tidy-row>
            <tidy-table
              #tidyTable
              [dataSource]="currentRows"
              [displayedColumns]="headers"
              [columnslabels]="headers"
              [allRowIsClickable]="true"
              [rowsToShow]="25"
              [showColumnLines]="false"
              (sortChange)="sortChanged($event)"
              (cellClick)="onTableColumnClick($event)"
              (pageChange)="pageChange($event)"
              [totalRows]="totalRows"
              [infiniteScroll]="true"
              [skipEntrance]="true"
              [blockSorting]="true" />
          </tidy-row>
        }
      }
      @if (isDataLoaded && currentRows?.length === 0) {
        <tidy-alert>
          <tidy-row>
            <tidy-text [body]="'No Results'" />
          </tidy-row>
        </tidy-alert>
      }
    }
  </tidy-wrapper>
</ng-template>

<app-scroll-wrapper
  [isfullWidthContent]="true"
[templateContent]="content" />